import { LoadingIcon } from "../../assets";
import { useInView } from "react-intersection-observer";
import React, { useCallback, useEffect } from "react";

type InfiniteScrollProps<T> = {
  className?: string;
  isLoading: boolean;
  hasNextPage: boolean;
  loadMore: () => void;
  data: Array<T>;
  renderItem: (item: T, key: number) => React.ReactElement;
  customLoadMoreElement?: (
    ref?: (node?: Element | null | undefined) => void
  ) => React.ReactElement;
};

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions,react/function-component-definition
function InfiniteScroll<T>({
  isLoading,
  hasNextPage,
  loadMore,
  data,
  renderItem,
  customLoadMoreElement,
}: InfiniteScrollProps<T>): React.ReactElement {
  const { ref, inView } = useInView();

  useEffect(() => {
    if (hasNextPage && inView && !isLoading) {
      loadMore();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView, hasNextPage, loadMore]);

  const loadMoreComponent = useCallback(
    (ref?: (node?: Element | null | undefined) => void) => (
      <section
        ref={isLoading ? null : ref}
        className=" grid h-[30px] w-full place-content-center place-items-center"
      >
        {isLoading && <LoadingIcon />}
      </section>
    ),
    [isLoading]
  );

  return (
    <React.Fragment>
      {data.map(renderItem)}
      {(hasNextPage || isLoading) &&
        (customLoadMoreElement
          ? customLoadMoreElement(isLoading ? undefined : ref)
          : loadMoreComponent(isLoading ? undefined : ref))}
    </React.Fragment>
  );
}

export { InfiniteScroll };
